import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom"
import { HomePage } from "./home"
import { LoginPage } from "./login"
import { PropsWithChildren } from "react"
import { useAuthContext } from "../hooks"
import { CieloCheckout } from "./checkout/cielo"

const routes = [
    {
        path: '/login',
        Element: LoginPage,
        isPrivate: false,
        isPublic: false
    }, {
        path: '/',
        Element: HomePage,
        isPrivate: true,
        isPublic: false
    },
    {
        path: '/checkout/cielo/:company_order_id',
        Element: CieloCheckout,
        isPrivate: false,
        isPublic: true
    }
]

const PrivateRoute = ({ children }: PropsWithChildren) => {
    return <>{children}</>
}

const PublicRoute = ({ children, isPublic }: PropsWithChildren & { isPublic: boolean }) => {
    const auth = useAuthContext()

    if (auth.signed && !isPublic) {
        window.location.href = '/'
        return null
    }

    return <>{children}</>
}

export const router = createBrowserRouter(routes.map(({path, Element, isPrivate, isPublic }) => {
    const Wrapper = isPrivate ? PrivateRoute : PublicRoute 
    console.log(path, isPrivate)
    return {
        path: path,
        element: (
            <Wrapper isPublic={isPublic}>
                <Element />
            </Wrapper>
        )
    }}
))


export const Routes = () => <RouterProvider router={router} />


  